import * as React from "react";
const BorderDashed = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 13H5v-1h3v1Zm6 0h-4v-1h4v1Zm2 0h3v-1h-3v1Z" }));
BorderDashed.displayName = "BorderDashed";
var BorderDashed_default = BorderDashed;
export {
  BorderDashed_default as default
};
